module.exports = __webpack_public_path__ + "static/media/MD_Pack Sheet for Copy_10312020.37072408.tsv";